import { PermissionWrapper } from "../../containers/wrappers/permission";

export const withPermission = (permission, children: JSX.Element) => {
  return <PermissionWrapper permission={permission}>{children}</PermissionWrapper>;
};
